// src/utils/toastUtil.js
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/NotificationToas.css'; // Optional custom styles

export const notificationToast = (data) => {
  const toastOptions = {
    className: 'custom-toast',
    bodyClassName: 'custom-toast-body',
    progressClassName: 'custom-toast-progress',
    autoClose: 5000,
  };

  // Combine title and content as plain text
  const message = `${data.title}: ${data.content}`;

  switch (data.type) {
    case 21:
      toast.success(message, toastOptions);
      break;
    case 2:
      toast.info(message, toastOptions);
      break;
    case 3:
      toast.warn(message, toastOptions);
      break;
    case 22:
      toast.error(message, toastOptions);
      break;
    default:
      toast(message, toastOptions); // default style
      break;
  }
};

export const CustomToastContainer = () => (
  <ToastContainer
  autoClose={5000}
  />
);
